// THIS FILE IS AUTOMATICALLY GENERATED. DO NOT MODIFY IT MANUALLY.

import { THEME_NAME, THEME_MODE } from '../../../symbol';

import baseTheme from '../../trellis/light/theme';

export type ThemeName = 'navy';

export type ThemeMode = 'light';

/**
 * Design System theme object.
 *
 * Theme name: `navy`
 *
 * Theme mode: `light`
 */
const theme = {
  ...baseTheme,
  color: {
    ...baseTheme.color,
    'fwc-button-border-inverse-default': '#cccccc',
    'fwc-button-border-inverse-default-alt': '#c93700',
    'fwc-button-border-inverse-disabled': 'rgba(255, 255, 255, 0)',
    'fwc-button-border-inverse-disabled-alt': 'rgba(255, 255, 255, 0)',
    'fwc-button-border-primary-default': '#c93700',
    'fwc-button-border-primary-disabled': 'rgba(255, 255, 255, 0)',
    'fwc-button-border-primary-hover': '#c93700',
    'fwc-button-border-primary-on-fill-default': '#cccccc',
    'fwc-button-border-primary-pressed': '#c93700',
    'fwc-button-border-secondary-default': '#cccccc',
    'fwc-button-border-secondary-default-alt': '#cccccc',
    'fwc-button-border-secondary-disabled': 'rgba(255, 255, 255, 0)',
    'fwc-button-border-secondary-disabled-alt': 'rgba(255, 255, 255, 0)',
    'fwc-button-border-secondary-toolbar-default': '#343446',
    'fwc-button-border-secondary-toolbar-disabled': 'rgba(20, 20, 20, 0)',
    'fwc-button-border-tertiary-default': 'rgba(255, 255, 255, 0)',
    'fwc-button-border-tertiary-disabled': 'rgba(255, 255, 255, 0)',
    'fwc-button-border-tertiary-on-fill-disabled': 'rgba(20, 20, 20, 0)',
    'fwc-button-border-transitional-tertiary-default': 'rgba(255, 255, 255, 0)',
    'fwc-button-fill-alert-default': '#d9002b',
    'fwc-button-fill-alert-hover': '#ac0020',
    'fwc-button-fill-alert-pressed': '#850016',
    'fwc-button-fill-field-default-alt': 'rgba(255, 255, 255, 0)',
    'fwc-button-fill-inverse-default': '#fcfcfc',
    'fwc-button-fill-inverse-default-alt': '#e74100',
    'fwc-button-fill-inverse-disabled': '#f0f0f0',
    'fwc-button-fill-inverse-disabled-alt': '#f0f0f0',
    'fwc-button-fill-inverse-hover': '#f2f2f2',
    'fwc-button-fill-inverse-hover-alt': '#c93700',
    'fwc-button-fill-inverse-pressed': '#e8e8e8',
    'fwc-button-fill-inverse-pressed-alt': '#9f2800',
    'fwc-button-fill-primary-default': '#e74100',
    'fwc-button-fill-primary-disabled': '#f0f0f0',
    'fwc-button-fill-primary-hover': '#c93700',
    'fwc-button-fill-primary-pressed': '#9f2800',
    'fwc-button-fill-secondary-default': '#fcfcfc',
    'fwc-button-fill-secondary-default-alt': '#fcfcfc',
    'fwc-button-fill-secondary-disabled': '#f0f0f0',
    'fwc-button-fill-secondary-disabled-alt': '#f0f0f0',
    'fwc-button-fill-secondary-hover': 'rgba(0, 0, 0, 0.04)',
    'fwc-button-fill-secondary-hover-alt': 'rgba(0, 0, 0, 0.04)',
    'fwc-button-fill-secondary-pressed': 'rgba(0, 0, 0, 0.08)',
    'fwc-button-fill-secondary-pressed-alt': 'rgba(0, 0, 0, 0.08)',
    'fwc-button-fill-tertiary-default': 'rgba(255, 255, 255, 0)',
    'fwc-button-fill-tertiary-disabled': '#f0f0f0',
    'fwc-button-fill-tertiary-hover': 'rgba(0, 0, 0, 0.04)',
    'fwc-button-fill-tertiary-pressed': 'rgba(0, 0, 0, 0.08)',
    'fwc-button-fill-transitional-tertiary-default': 'rgba(255, 255, 255, 0)',
    'fwc-button-fill-transitional-tertiary-hover': 'rgba(0, 0, 0, 0.04)',
    'fwc-button-fill-transitional-tertiary-pressed': 'rgba(0, 0, 0, 0.08)',
    'fwc-button-specialty-link-on-fill-alt-default': '#1160ab',
    'fwc-button-specialty-link-on-fill-alt-pressed': '#00305e',
    'fwc-button-specialty-primary-on-fill-default': '#fcfcfc',
    'fwc-button-specialty-primary-on-fill-disabled': '#f0f0f0',
    'fwc-button-specialty-primary-on-fill-hover': '#f2f2f2',
    'fwc-button-specialty-primary-on-fill-pressed': '#e8e8e8',
    'fwc-button-specialty-secondary-toolbar-default': '#23232e',
    'fwc-button-specialty-secondary-toolbar-disabled': '#272735',
    'fwc-button-specialty-secondary-toolbar-hover': '#272735',
    'fwc-button-specialty-secondary-toolbar-pressed': '#2f2f46',
    'fwc-button-specialty-tertiary-on-fill-default': 'rgba(20, 20, 20, 0)',
    'fwc-button-specialty-tertiary-on-fill-disabled': '#272735',
    'fwc-button-specialty-tertiary-on-fill-hover': 'rgba(255, 255, 255, 0.02)',
    'fwc-button-specialty-tertiary-on-fill-pressed': 'rgba(255, 255, 255, 0.1)',
    'fwc-button-specialty-tertiary-transparent-disabled': '#f0f0f0',
    'fwc-button-specialty-tertiary-transparent-hover': 'rgba(0, 0, 0, 0.04)',
    'fwc-button-specialty-tertiary-transparent-pressed': 'rgba(0, 0, 0, 0.08)',
    'fwc-button-specialty-text-core-alt-default': '#1160ab',
    'fwc-button-text-interactive-default': '#1160ab',
    'fwc-button-text-interactive-default-hover': '#00417c',
    'fwc-button-text-interactive-default-pressed': '#00305e',
    'fwc-button-text-inverse-disabled-alt': '#b3b3b3',
    'fwc-button-text-primary-disabled': '#b3b3b3',
    'fwc-button-text-primary-on-fill-disabled': '#b3b3b3',
    'fwc-button-text-secondary-disabled': '#b3b3b3',
    'fwc-button-text-secondary-ghost-disabled': '#b3b3b3',
    'fwc-button-text-secondary-toolbar-disabled': '#5f637c',
    'fwc-button-text-tertiary-disabled': '#b3b3b3',
    'fwc-button-text-tertiary-on-fill-disabled': '#5f637c',
    'fwc-link-specialty-link-on-fill-alt-default': '#1160ab',
    'fwc-link-specialty-link-on-fill-alt-hover': '#00417c',
    'fwc-link-specialty-link-on-fill-alt-pressed': '#00305e',
    'fwc-link-specialty-text-core-alt-default': '#1160ab',
    'fwc-link-text-interactive-default': '#1160ab',
    'fwc-link-text-interactive-default-hover': '#00417c',
    'fwc-link-text-interactive-default-pressed': '#00305e',
    'fwc-link-underline-hover': '#00417c',
    'fwc-link-underline-pressed': '#00305e',
    'fwc-table-border-color-focused': '#0050c7',
  },
};

Object.assign(theme, {
  [THEME_NAME]: 'navy',
  [THEME_MODE]: 'light',
});

export default theme;
